import { AfterViewInit, Component, inject, input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Event, NavigationStart, Router, RouterOutlet } from '@angular/router';
import { ErrorService } from '@eforall/common';
import { DashboardMenuService } from '../services';
import { BackTopPart } from './parts/back-top/back-top.part';
import { BreadcrumbPart } from './parts/breadcrumb/breadcrumb.part';
import { MenuPart } from './parts/menu/menu.part';
import { NavbarPart } from './parts/navbar/navbar.part';

@Component({
	selector: 'dashboard-frame',
	standalone: true,
	imports: [
		NavbarPart,
		MenuPart,
		BreadcrumbPart,
		BackTopPart,
		RouterOutlet,
	],
	templateUrl: './dashboard.frame.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./dashboard.frame.scss']
})
export class DashboardFrame implements OnInit, AfterViewInit {

	public errorService = inject(ErrorService);
	public menu = inject(DashboardMenuService);
	private router = inject(Router);

	public routerIsNavigating = false;
	moveSpeed = input(1000); // Use input()

	mainWrapper: HTMLElement | null = null;

	public isSpanish = false;

	ngOnInit() {
		this.router.events.subscribe((event: Event) => {
			if (event instanceof NavigationStart) {
				this.routerIsNavigating = true;
				setTimeout(() => {
					if (this.mainWrapper) {
						this.mainWrapper.scrollTo({ top: 0, behavior: 'smooth' });
					} else {
						console.error("Main wrapper element not found!");
					}
				}, 500);
			}
		});

	}

	ngAfterViewInit() {
		this.mainWrapper = document.querySelector('.main-wrapper');
		if (!this.mainWrapper) {
			console.error("Main wrapper not found.  Make sure you have an element with the class 'main-wrapper'");
		}
	}


	public hideMenu(): void {
		this.menu.setMenuCollapsed(true);
	}
}